import '/assets/styles/pages/web-menu.scss';

// Sections
import PageHeader from '/views/sections/page-header';
import OrderLookupSection from '/views/sections/order-lookup';

// Context
import { useTranslation } from '/utilities/i18n';

const OrderLookup = () => {
	const { t } = useTranslation();

	return (
		<>
			<PageHeader backLink={false} title={t('Sipariş Sorgulama')} />
			<OrderLookupSection />
		</>
	);
};

export default OrderLookup;
